import { v4 as uuidv4 } from 'uuid';

export function AvailabilityNotify() {
	return {
		componentName: 'AvailabilityNotify',
		componentId: uuidv4(),
		props: {},
		childrenComponents: [],
	};
}
